import { createRouter, createWebHistory } from "vue-router";
import SchedaView from "../views/SchedaView.vue";
import HomeView from "../views/HomeView.vue";
//import ProductDetail from "../views/ProductDetail.vue";
// import webApiProxy from "@/services/webApiProxy.js";
import NProgress from 'nprogress';
import store from '@/store'
import NotFound from '@/views/NotFound.vue'
import NetworkError from '@/views/NetworkError.vue'
import ErrorDisplay from '@/views/ErrorDisplay.vue'
import UnderConstruction from '@/views/UnderConstruction.vue'
import OrdineCompletato from '@/views/OrdineCompletato.vue'

const routes = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
  },
  {
    path: "/scheda/:category/:codListino",
    name: "Scheda",
    props: true, 
    component: SchedaView,
    alias: '/scheda-new/:category/:codListino',
    beforeEnter: async (to) => {

      return await store.dispatch('setSchedaData', {codListino: to.params.codListino, codVar: to.query.codvar})
        .catch(error => {
          console.log('scheda beforeEnter() - setSchedaData: ' + error);
            if (error.response && error.response.status == 404) {
              return { 
                name: '404Resource',
                params: { resource: to.params.codListino }
              }
            } 
            else {
              return { name: 'NetworkError' }
            }
        });
    }
  },
  {
    path: "/personalizza",
    name: "CarrelloPers",
    //meta: { requireAuth: true },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CarrelloPersView.vue"),
    beforeEnter: ()/*async (to)*/ => {
      // if(process.env.NODE_ENV === 'production'){
      //   return { name: 'UnderConstruction' }
      // }
      // else{
        if(!store.state.loggedUserInfo){  //&& to.meta.requireAuth
          document.location = `/`;
          return false;
        }
        else if(store.state.schedaAppData == null || 
          store.state.schedaAppData.prodottoInfo == null ||
          store.state.schedaAppData.prodottoInfo.ListaPersonalizzazioni.length == 0){
           document.location = '/search';
           return false;
        }
      //}
    }
  },
  {
    path: "/carrello",
    name: "CarrelloView",
    meta: { requireAuth: true },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CarrelloView.vue"),
  },
  {
    path: "/checkout",
    name: "CarrelloCheckoutView",
    meta: { requireAuth: true },
    props: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CarrelloCheckoutView.vue"),
    // beforeEnter: ()/*async (to)*/ => {
    //   if(process.env.NODE_ENV === 'production'){
    //     return { name: 'UnderConstruction' }
    //   }
    // }
  },
  {
    path: '/network-error', 
    name: 'NetworkError',
    component: NetworkError
  },
  {
    path: '/under-construction',
    name: 'UnderConstruction',
    component: UnderConstruction
  },
  {
    path: '/error/:error',
    name: 'ErrorDisplay',
    props: true,
    component: ErrorDisplay
  },
  {
    path: '/404/:resource',
    name: '404Resource',
    component: NotFound,
    props: true
  },
  {
    path: '/ordine-completato/:n/:ord',
    name: 'OrdineCompletato',
    component: OrdineCompletato,
    props: true
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(/*to, from, savedPosition*/) {
    // always scroll to top
    return { top: 0 }
  },
});

router.beforeEach(async (to) => {
  NProgress.start();

  //Controllo autenticazione utente
  await store.dispatch('getLoggedUser')
    .catch(error => {
      console.log('scheda beforeEnter() - getLoggedUser: ' + error);
    });
  
    if(!store.state.loggedUserInfo && to.meta.requireAuth){
      //next('/Accesso');
      document.location = `/Accesso?returnurl=${to.fullPath}`;
      return false;
    } 
})

router.afterEach(() => {
  NProgress.done()
})


export default router;

//Backup codice se serve per redirect
// {
  //   path: "/app/:category/:codListino",
  //   redirect: /*to*/ () => {
  //     // the function receives the target route as the argument
  //     // we return a redirect path/location here.
  //     //Si potrebbe fare anche così. Ma vue router notifica con un warning di utilizzare una named route anzichè specificare il path con i params.
  //     //return { path: `/scheda/${to.params.category}/${to.params.codListino}`/*, query: { q: to.params.searchText }*/ }
  //     return { name: 'Scheda' } 
  //   },
  // },
  // {
  //   path: "/app/personalizza",
  //   redirect: /*to*/ () => {
  //     // the function receives the target route as the argument
  //     // we return a redirect path/location here.
  //     return { path: '/personalizza'/*, query: { q: to.params.searchText }*/ }
  //   },
  // },
